import { DateTimePart, DateTimeService, TimeUnitUtils, useTimezone } from '@mews/framework';

export const useDateRangeBySelectedFilterDate = (dateTimeUtcString: string) => {
    const timezone = useTimezone();

    const dateTime = DateTimeService.fromUtcString(dateTimeUtcString, timezone);
    const startDateTime = TimeUnitUtils.getTimeUnitStart(dateTime, 'day');
    const endDateTime = TimeUnitUtils.getNextTimeUnitStart(dateTime, DateTimePart.Day);

    return {
        startLocal: startDateTime,
        endLocal: endDateTime,
    };
};
